var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhidataVectorized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "86.000000pt",
    height: "107.000000pt",
    viewBox: "0 0 86.000000 107.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,107.000000) scale(0.100000,-0.100000)",
    fill: "grey",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 950 l0 -49 58 -3 57 -3 3 -42 3 -42 -108 -3 -108 -3 -3 -262 -2 -262 107 -3 108 -3 0 -45 0 -45 -57 -3 -58 -3 0 -44 0 -45 165 0 165 0 0 45 0 44 -57 3 -58 3 0 45 0 45 108 3 107 3 -2 262 -3 262 -95 2 c-52 1 -101 2 -108 2 -9 1 -12 14 -10 44 l3 42 58 3 57 3 0 49 0 50 -165 0 -165 0 0 -50z m118 -407 l2 -162 -23 -6 c-13 -4 -39 -5 -58 -3 l-34 3 -3 168 -2 168 57 -3 58 -3 3 -162z m213 25 c1 -134 0 -180 -5 -185 -7 -7 -79 -13 -96 -8 -19 6 -20 15 -20 164 0 87 3 161 7 164 3 4 30 7 60 7 l53 0 1 -142z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhidataVectorized);
export default __webpack_public_path__ + "static/media/phidata_vectorized.306a3aa588d2014698e126ed670334cf.svg";
export { ForwardRef as ReactComponent };